
import { useContext } from 'react';
import { LoginModalContext } from '../../loginModalProvider';

const useLoginModal = () => {
  const context = useContext(LoginModalContext);
  if (!context) {
    throw new Error('useLoginModal must be used within a LoginModalProvider');
  }
  return context;
};

export default useLoginModal;
